import { Controller } from "@hotwired/stimulus"
import { createChart, AreaSeries } from 'lightweight-charts';

export default class extends Controller {
  connect() {
    this.initChart()
  }

  async initChart() {
    const options = {
      layout: {
        attributionLogo: false,
        background: { type: 'solid', color: 'white' },
        textColor: 'rgba(33, 56, 77, 1)',
      },
      grid: {
        vertLines: {
          color: 'rgba(197, 203, 206, 0.0)',
        },
        horzLines: {
          color: 'rgba(197, 203, 206, 0.0)',
        },
      },
      rightPriceScale: {
        borderVisible: false,
      },
      leftPriceScale: {
        borderVisible: false,
      },
      priceScale: {
        autoScale: false, // Disable auto-scaling
      },
      timeScale: {
        borderVisible: false,
        timeVisible: false,
      },
      autoSize: true,
      handleScroll: false, // Disable scroll events
      handleScale: false, // Disable zoom events
    };

    const chart = createChart(this.element, options);
    const areaSeries = chart.addSeries(AreaSeries, {
      color: '#2962FF',
      lineWidth: 2,
      priceFormat: {
        type: 'volume'
      },
    });

    const series = await this.data();
    areaSeries.setData(series);
    chart.timeScale().fitContent();
  }

  async data() {
    return fetch('/cardano_metrics/unique_active_wallets', {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error('Error fetching time series data:', error);
      return [];
    });
  }
}
